import { createSlice } from '@reduxjs/toolkit';

const activeCompanyFromStorage = localStorage.getItem('adminCompany')
    ? JSON.parse(localStorage.getItem('adminCompany'))
    : null;

const adminSlice = createSlice({
    name: 'admin',
    initialState: {
        activeCompany: activeCompanyFromStorage,
    },
    reducers: {
        setActiveCompany: (state, action) => {
            state.activeCompany = action.payload;
            localStorage.setItem('adminCompany', JSON.stringify(action.payload));
        },
        clearActiveCompany: (state) => {
            state.activeCompany = null;
            localStorage.removeItem('adminCompany');
        },
    },
});

export const { setActiveCompany, clearActiveCompany } = adminSlice.actions;
export default adminSlice.reducer;
